import { ChangeEvent, useEffect } from 'react'
import { Badge, HStack, Input, Stack } from '@chakra-ui/react'

import CustomFormFieldErrorMessage from 'components/tools/CustomForm/commonComponents/CustomFormFieldErrorMessage'
import { CustomFormViewerQuestionProps } from 'components/tools/CustomForm/types/CustomFormViewerQuestionProps'
import validateNumberOnCustomForm from 'components/tools/CustomForm/components/Viewer/utils/validateNumberOnCustomForm'
import { useCustomFormViewer } from 'components/tools/CustomForm/components/Viewer/contexts/CustomFormViewerManager/Provider'
import useCustomFormGetDefaultValue from '../../hooks/useCustomFormGetDefaultValue'

export default function CustomFormNumberQuestion({
  question,
  questionKey,
  formMethods,
  disabled,
}: CustomFormViewerQuestionProps) {
  const { removeErrorFromQuestion, setErrorOnQuestion, thisQuestionHasError } = useCustomFormViewer()

  const { defaultValue } = useCustomFormGetDefaultValue({ question, questionKey, disabled })

  const questionWithError = thisQuestionHasError(question.slug)?.question

  function handleValidateNumberQuestion(number: string) {
    const errorMessage = validateNumberOnCustomForm({ number, question })
    if (errorMessage === '') {
      removeErrorFromQuestion(question.slug)
    } else {
      setErrorOnQuestion(question, errorMessage)
    }
  }

  function handleOnBlur(event: ChangeEvent<HTMLInputElement>) {
    const inputValue = event.target.value

    handleValidateNumberQuestion(inputValue)
  }

  useEffect(() => {
    if (defaultValue) {
      handleValidateNumberQuestion(defaultValue)
    }
    if (formMethods?.setValue) {
      formMethods.setValue(questionKey, defaultValue)
    }
  }, [defaultValue])

  return (
    <Stack>
      <Input
        id={question.slug}
        type="number"
        inputMode="numeric"
        isDisabled={disabled}
        placeholder={question?.placeholder}
        value={formMethods?.watch ? formMethods.watch(questionKey) : defaultValue}
        {...(formMethods?.register && formMethods.register(questionKey, { onBlur: handleOnBlur }))}
      />

      <CustomFormFieldErrorMessage message={questionWithError?.error_message} />

      {question.validation && (
        <HStack flexWrap="wrap">
          {question.validation.min && <Badge textTransform="none">Mínimo ({question.validation.min})</Badge>}
          {question.validation.max && <Badge textTransform="none">Máximo ({question.validation.max})</Badge>}
        </HStack>
      )}
    </Stack>
  )
}
